import type { FooterData } from '@/data/types';

interface FooterProps {
  footerData?: FooterData;
}

export function Footer({ footerData }: FooterProps) {
  // Default values matching the original site
  const copyright = footerData?.copyright || {
    year: "2025",
    siteName: "Air Haven",
    siteUrl: "/",
    allRightsReserved: "All rights reserved"
  };

  const theme = footerData?.theme || {
    attribution: "Theme by",
    themeUrl: "https://wp-puzzle.com/",
    themeName: "WP Puzzle"
  };

  return (
    <footer id="footer" className="bg-blue-600 text-white py-4">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col sm:flex-row justify-between items-center text-sm">
          {/* Copyright section */}
          <div className="flex flex-wrap items-center gap-1 mb-2 sm:mb-0">
            <p id="copy" className="flex items-center gap-1">
              © {copyright.year}{' '}
              <a 
                href={copyright.siteUrl} 
                className="text-white hover:text-blue-200 transition-colors"
              >
                {copyright.siteName}
              </a>
              <span>{copyright.allRightsReserved}</span>
            </p>
          </div>

          {/* Theme attribution */}
          <div>
            <p id="designedby" className="flex items-center gap-1">
              {theme.attribution}{' '}
              <a 
                href={theme.themeUrl} 
                className="text-white hover:text-blue-200 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                {theme.themeName}
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}